import { PageLoader } from "@/components/ui/Spinner";
import { useAuthStore } from "@/store/auth";

import { BillingPeriodRow } from "../components/BillingPeriodRow";
import { useBillingPeriods } from "../hooks/useEmployeeAgreements";

export function EmployeeBillingOverviewPage() {
  const user = useAuthStore((s) => s.user);
  const { data: periods = [], isLoading } = useBillingPeriods();

  if (isLoading) return <PageLoader />;

  return (
    <div className="p-6 flex flex-col gap-4">
      <h1 className="text-lg font-mono uppercase tracking-wider">
        Rozliczenia podpisów pracowników
      </h1>
      {periods.length === 0 ? (
        <div className="text-sm text-[var(--color-text-muted)] py-8 text-center">
          Brak okresów do wyświetlenia.
        </div>
      ) : (
        <div className="flex flex-col gap-3">
          {periods.map((p) => (
            <BillingPeriodRow
              key={p.id}
              period={p}
              canMarkPaid={!!user?.is_ceo}
              canUploadInvoice={false}
            />
          ))}
        </div>
      )}
    </div>
  );
}
